import { render, staticRenderFns } from "./DashboardDelete.vue?vue&type=template&id=2ada7733&"
import script from "./DashboardDelete.vue?vue&type=script&lang=js&"
export * from "./DashboardDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports